export const SIDEBAR_WIDTH_EXPANDED = 250;
export const SIDEBAR_WIDTH_MINI = 72;
